<label *ngIf="label && !isCompoundFieldMember && showLabel"
  [attr.for]="id"
  soho-label
    [required]="isRequired"
  lm-label
    [layoutField] = "field"
    [personalize]="personalize && !field?.label?.textStyle?.color"
  lm-text-style
    [textStyle]="field?.label?.textStyle"
>{{triggerValue| formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
</label>

<ng-container [ngSwitch]="formType">
  <ng-container *ngSwitchCase="formDisplayType.SEARCH_FORM">
    <ng-container *ngIf="isCompoundFieldMember; else NormalFieldOnSearchForm">
      <!-- On a search form and in the preview mode (occurs in the lm-compact-dialog modal) -->
      <ng-container *ngIf="lmParagraphLayoutInfo.previewMode; then CompoundPlaceHolderDisplayPreviewMode; else NormalMode"></ng-container>
      <!-- On a search form, just a compound field member NOT in the preview -->
      <ng-template #NormalMode>
        <div>
          <div [ngStyle]="{'display': showField ? 'inline-block' : 'none' }">
            <input
              [ngClass]="fieldClassesString"
              [attr.id]="id"
              [attr.bindId]="bindId"
              [attr.aria-label]="triggerValue | formatLabelRule:field:labelResourceValue:model:specFields"
              [ngModel]="modelField.value | toDisplayValue:specField:transformOptions"
              (ngModelChange)="onNgModelChange($event)"
              soho-timepicker
                [timeFormat]="timeFormat"
                [mode]="mode"
                [minuteInterval]="minuteInterval"
                [secondInterval]="secondInterval"
                [tabbable]="!(!isInAccessibilityMode || isReadOnly || isCompoundFieldMember)"
              (focus)="onFocus($event)"
              (blur)="onBlur($event)"
              (change)="onTimeChange()"
            />
          </div>
          <!-- Handle displaying the label or value as text when not showField (the field isn't focused)-->
          <ng-container *ngIf="true; then CompoundPlaceHolderDisplayNormalMode"></ng-container>
        </div>
      </ng-template>
    </ng-container>
    <!-- On a search form, NOT a compound member field-->
    <ng-template #NormalFieldOnSearchForm>
      <input
        #Input
        [ngClass]="fieldClassesString"
        [attr.id]="id"
        [attr.bindId]="bindId"
        [ngModel]="modelField.value | toDisplayValue:specField:transformOptions"
        (ngModelChange)="onNgModelChange($event)"
        soho-timepicker
          [timeFormat]="timeFormat"
          [mode]="mode"
          [minuteInterval]="minuteInterval"
          [secondInterval]="secondInterval"
          [tabbable]="!(!isInAccessibilityMode || isReadOnly || isCompoundFieldMember)"
        soho-tooltip content="{{modelField.value | toDisplayValue:specField:transformOptions}}"
        soho-field-filter
          [fieldDropdownDataSet]="numericFilterSettings"
          [selectedFilterType]="triggerValue | toFieldOperator : modelField"
          (filtered)="onFiltered($event)"
        (blur)="onBlur($event)"
        (change)="onTimeChange()"
      />
    </ng-template>
  </ng-container>
  <!-- Not on a search form -->
  <ng-container *ngSwitchDefault>
    <div
      [ngClass]="{'disabled-member-field': disabledMemberField, 'lm-is-display-as-tag': layoutDisplayType.DISPLAY_AS_TAG}"
      lm-field-options
        [isMemberField]="isCompoundFieldMember"
        [dataEntryMode]="dataEntryMode"
        [hasContextMenu]="insertContextMenu"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
      lm-layout-util
        [hideWhiteSpace]="!(lmColumnLayoutInfo && lmColumnLayoutInfo.nbrColumns > 1)"
      soho-tooltip
        [popover]="true"
        [title]="popoverTitle"
        [placement]="'right'"
        [trigger]="'click'"
      (contextmenu)="onContextMenu($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)">
      <ng-container [ngSwitch]="displayType">
        <ng-container *ngSwitchCase="layoutDisplayType.PLAIN">
          <!--
            wrapper div so icon doesn't float outside of container, when parent is display flex
            icon is dynamically inserted into the DOM via ids-enterprise controls
          -->
          <div [ngStyle]="{'display': showField ? 'inline-block' : 'none'}">
            <input
              #Input
              [ngClass]="fieldClassesString"
              [attr.id]="id"
              [attr.bindId]="bindId"
              [attr.readOnly]="isReadOnly ? true : null"
              [attr.aria-label]="(isCompoundFieldMember) ? (triggerValue | formatLabelRule:field:labelResourceValue:model:specFields) : null"
              [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && isReadOnly ? -1 : null"
              [ngModel]="modelField.value | toDisplayValue:specField:transformOptions"
              (ngModelChange)="onNgModelChange($event)"
              soho-timepicker
                [timeFormat]="timeFormat"
                [mode]="mode"
                [minuteInterval]="minuteInterval"
                [secondInterval]="secondInterval"
                [tabbable]="!(!isInAccessibilityMode || isReadOnly || isCompoundFieldMember)"
              soho-alert
              soho-trackdirty
                (dirty)="onDirty($event)"
                (pristine)="onPristine($event)"
                (afterResetDirty)="onAfterResetDirty($event)"
              soho-input-validate
                (error)="onError($event)"
                (valid)="onValid($event)"
              (blur)="onBlur($event)"
              (input)="onInput($event)"
            />
          </div>
        </ng-container>

        <!-- display as tag -->
        <ng-container *ngSwitchCase="layoutDisplayType.DISPLAY_AS_TAG">
          <span
              attr.id="{{id}}"
              class="tag is-dismissible"
              [ngStyle]="{'color': '#FFFFFF', 'outline': 'none'}"
              [ngClass]="{
                'lm-compound-text': isCompoundFieldMember,
                'lm-text-data': !isCompoundFieldMember,
                'is-active': isFieldTagFocused,
                'is-focused': isFieldTagFocused,
                'hide-focus': !isFieldTagFocused
              }"
              soho-alert
              lm-field-style
                [fieldStyle]="tagStyle?.style"
                [isTag]="true"
              [attr.tabindex]="isInAccessibilityMode ? 0 : null"
              (focus)="onTagFocus()"
              (blur)="onTagBlur()"
          >{{modelField.value | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</span>
        </ng-container>

        <!-- display as text -->
        <p *ngSwitchCase="layoutDisplayType.DISPLAY_AS_TEXT"
            class="hide-white-space"
            attr.id="{{id}}"
            [attr.tabindex]="isInAccessibilityMode ? 0 : null"
            [class.lm-compound-text]="isCompoundFieldMember"
            [class.lm-text-data]="!isCompoundFieldMember"
            [ngStyle]="{'display': 'inline-block'}"
            soho-alert
              [class.personalize-text]="personalize && !layoutObject?.fieldStyle?.color"
            lm-field-style
              [fieldStyle]="layoutObject?.fieldStyle"
              [specField]="specField"
        >{{modelField.value | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>

        <!-- Handle the compound field member display label/value not focused in compact format on a form -->
        <ng-container *ngIf="isCompoundFieldMember">
          <div *ngIf="lmParagraphLayoutInfo?.previewMode; then CompoundPlaceHolderDisplayPreviewMode; else CompoundPlaceHolderDisplayNormalMode"></div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #CompoundPlaceHolderDisplayNormalMode>
  <span *ngIf="isDirty" class="icon-dirty lm-compound-member-field-dirty"></span>
  <ng-container *ngIf="!(modelField.value | isBlankValue:specField); else noValue" >
    <p
        attr.id="{{id}}-text"
        class="lm-compound-text hide-white-space"
        [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
        [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
        soho-alert
        soho-trackdirty
        [searchForm]="onSearchForm"
        (dirty)="onDirty($event)"
        (pristine)="onPristine($event)"
        (afterResetDirty)="onAfterResetDirty($event)"
        (focus)="onFocus($event)"
    >{{modelField.value | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
  </ng-container>
  <ng-template #noValue>
    <p
        attr.id="{{id}}-text"
        [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
        [ngClass]="{'lm-compound-text preview-placeholder': true, 'input-style is-placeholder': !isReadOnly}"
        [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
        soho-tooltip
        [content]="showLabel ? '' : triggerValue | formatMessageRule:false:labelResourceValue:model:specFields"
        soho-alert
        soho-trackdirty
        [searchForm]="onSearchForm"
        (dirty)="onDirty($event)"
        (pristine)="onPristine($event)"
        (afterResetDirty)="onAfterResetDirty($event)"
        (focus)="onFocus($event)"
    >{{triggerValue | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
  </ng-template>
</ng-template>

<ng-template #CompoundPlaceHolderDisplayPreviewMode>
  <ng-container *ngIf="!(modelField.value | isBlankValue:specField); else noValue" >
    <p
        attr.id="{{id}}-text"
        [attr.aria-label]="triggerValue | formatLabelRule:field:labelResourceValue:model:specFields"
        class="lm-compound-text hide-white-space"
        [ngStyle]="{'display': 'inline-block'}"
        soho-alert
        soho-tooltip
        [content]="showLabel ? '' : triggerValue | formatMessageRule:false:labelResourceValue:model:specFields"
    >{{modelField.value | toDisplayValue:specField:transformOptions | formatMessageRule:true:layoutObject.title:model:specFields}}</p>
  </ng-container>
  <ng-template #noValue>
    <p
        attr.id="{{id}}-text"
        [attr.aria-label]="triggerValue | formatLabelRule:field:labelResourceValue:model:specFields"
        class="lm-compound-text input-style is-placeholder preview-placeholder"
        [ngStyle]="{'padding-top': '0'}"
        soho-alert
    >{{triggerValue | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
  </ng-template>
</ng-template>

<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>
